import { render } from "./callback.vue?vue&type=template&id=2a546a6b&scoped=true"
import script from "./callback.vue?vue&type=script&lang=js"
export * from "./callback.vue?vue&type=script&lang=js"

import "./callback.vue?vue&type=style&index=0&id=2a546a6b&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a546a6b"]])

export default __exports__